import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import "antd/dist/antd.variable.min.css";
import "./index.scss";
import App from "./App";
import request from "axios";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { change_icon, fixArray } from "./unit/unit";
import Login from "./pages/Login";
import NotFound from "./pages/404";
import PrivateRoute from "./components/PrivateRoute";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import TaskDetails from "./pages/TaskDetails/index";

dayjs.locale("zh-cn");

fixArray();

const root = ReactDOM.createRoot(document.getElementById("root"));
// ConfigProvider.config({
//   theme: {
//     primaryColor: "#0068B2",
//   },
// });
const url = `${
  process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : "/afc/"
}compose/get_app_config`;

request.get(url).then((res) => {
  localStorage.setItem("prefix", res.data?.data?.prefix || "");
  localStorage.setItem("sub_url", res.data?.data?.sub_url || "");
  localStorage.setItem("sys_url", res.data?.data?.sys_url || "");
  localStorage.setItem("deploy", res.data?.data?.deploy || "SAAS");
  localStorage.setItem("product_name", res.data?.data?.product_name || "");
  localStorage.setItem("logo_url", res?.data?.data?.logo_url || "");
  localStorage.setItem("logo_sidebar_url", res?.data?.data?.logo_sidebar_url || "");
  localStorage.setItem("preview_path", res?.data?.data?.preview_path || "");
  localStorage.setItem(
    "web_title",
    res.data?.data?.web_title || "网络核查系统"
  );

  if (res.data?.data?.page_title_icon) {
    change_icon(res.data?.data?.page_title_icon);
  }

  // 自定义圆角配置
  const customBorderRadius = {
    // 设置选择框的圆角
    Select: {
      borderRadius: 4, // 正常状态圆角
    },
    Input: {
      borderRadius: 4, // 正常状态圆角
    },
    DatePicker: {
      borderRadius: 4, // 正常状态圆角
    },
    Button: {
      borderRadius: 4, // 正常状态圆角
    },
    Radio: {
      borderRadius: 4, // 正常状态圆角
    },
  };

  root.render(
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#0068B2",
        },
        components: customBorderRadius,
      }}
    >
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/404" element={<NotFound />} />
            <Route
              path="/taskDetails/:id"
              element={
                <PrivateRoute>
                  <App element={<TaskDetails></TaskDetails>} />
                </PrivateRoute>
              }
            />
            <Route
              path="*"
              element={
                <PrivateRoute>
                  <App />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Provider>
    </ConfigProvider>
  );
});
